import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
// import ImagesDetail from "../Images/ImagesDetail";
import parse, { domToReact } from "html-react-parser";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import ImagesDetail from "./imagesDetail";
import "styles/term.css";

function OrderInformation({
    orderInfo,
    termData,
    takeScreenshot,
    p = 2,
    mt = -1
}) {

    const [openDialog, setOpenDialog] = useState(
        window.location.hash.replace("#", "")
    );

    const [openImageDetail, setOpenImageDetail] = useState({
        open: false
    });

    const [serviceType, setServiceType] = useState({
        rallyPartner: false,
        ballBoy: false,
        coach: false,
        rent: false,
        sell: false
    });

    const [outdoorExist, setOutdoorExist] = useState(false);

    useEffect(() => {
        const handleHashChange = () => {
            setOpenDialog(window.location.hash.replace("#", ""));
        };

        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    useEffect(() => {
        if (
            openDialog === "terms-condition" ||
            openDialog === "terms-condition-theballroom" ||
            openDialog === "terms-condition-terra"
        ) {
            setOpenImageDetail({ open: true });
        } else {
            setOpenImageDetail({ open: false });
        }
    }, [openDialog]);

    useEffect(() => {
        let isCourtBooking = true;

        if (orderInfo && orderInfo.productOrder && orderInfo.productOrder.length > 0) {
            let rallyPartner = false;
            let ballBoy = false;
            let coach = false;
            let rent = false;
            let sell = false;

            for (let i = 0; i < orderInfo.productOrder.length; i++) {
                const category = orderInfo.productOrder[i]?.productInfo?.category;

                const coachTypes = new Set([
                    "Coach",
                    "Development Coach",
                    "Lead Coach",
                    "Head Coach",
                    "Senior Coach"
                ]);

                if (category === "Rally Partner") rallyPartner = true;
                else if (category === "Ball Boy") ballBoy = true;
                else if (coachTypes.has(category)) coach = true;
            }

            if (orderInfo.orderType === "rent") rent = true;
            else if (orderInfo.orderType === "sell") sell = true;

            isCourtBooking = false;

            setServiceType({
                rallyPartner,
                ballBoy,
                coach,
                rent,
                sell
            });
        } else {
            if (orderInfo?.orderType === "rent" || orderInfo?.orderType === "sell") {
                isCourtBooking = false;
                setServiceType({
                    rallyPartner: false,
                    ballBoy: false,
                    coach: false,
                    rent: orderInfo.orderType === "rent",
                    sell: orderInfo.orderType === "sell"
                });
            }

            if (orderInfo?.orderType === "value_pack") isCourtBooking = false;
            if (orderInfo?.orderType === "class") isCourtBooking = false;
        }

        setOutdoorExist(isCourtBooking);
    }, [orderInfo]);

    if (!termData) {
        termData = orderInfo?.termData;
    }

    const handleCloseImageDetail = (e) => {
        setOpenImageDetail({
            open: e,
            image: null
        });
        window.location.hash = "";
    };

    const getImageSrc = () => {
        if (openDialog === "terms-condition-theballroom") {
            return "https://top-court.s3-ap-southeast-1.amazonaws.com/topcourt-staging/1772984087945.png";
        }
        if (openDialog === "terms-condition-terra") {
            return "https://top-court.s3-ap-southeast-1.amazonaws.com/topcourt-staging/1773757632829.png";
        }

        return "https://top-court.s3.ap-southeast-1.amazonaws.com/topcourt-staging/tennis_courts_rules.jpg";
    };

    return (
        <Grid p={takeScreenshot ? 2 : p} pt={0} mt={mt} sx={{ color: "#025597" }}>
            {orderInfo?.term && orderInfo.term.length > 0 ? (
                orderInfo.term.map((item, index) => (
                    <Grid
                        key={index}
                        display="flex"
                        alignItems="center"
                        className="term-content"
                    >
                        <TCLabel
                            subtitle
                            inheritColor
                            component="span"
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                marginBottom: 0
                            }}
                        >
                            <span>
                                {parse(item, {
                                    replace: (domNode) => {
                                        if (domNode.name === "a") {
                                            const href = domNode.attribs?.href || "";

                                            if (
                                                href === "#terms-condition" ||
                                                href === "#terms-condition-theballroom" ||
                                                href === "#terms-condition-terra"
                                            ) {
                                                return (
                                                    <a
                                                        href={href}
                                                        style={{
                                                            cursor: "pointer",
                                                            textDecoration: "underline"
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            window.location.hash = href.replace("#", "");
                                                        }}
                                                    >
                                                        {domToReact(domNode.children || [])}
                                                    </a>
                                                );
                                            }
                                        }
                                    }
                                })}
                            </span>
                        </TCLabel>
                    </Grid>
                ))
            ) : (
                <TCLabel text="No terms to display" fontSize={12} color="#999" />
            )}

            <ImagesDetail
                disableZoom={true}
                open={openImageDetail.open}
                setOpen={handleCloseImageDetail}
                src={getImageSrc()}
            />
        </Grid>
    );
}

export default OrderInformation;